import React from 'react';


const urlPlantilla = "https://d30w7gr6b4xk5o.cloudfront.net/plantilla_solicitud_ese_v1.xlsx"

const CLinkDescargaPlantillaCrearEse = () => {
  
  return (
    
    <p>
      <a href={urlPlantilla} target="_blank" rel="noreferrer">
        Plantilla para solicitar estudios
        <img src="https://d30w7gr6b4xk5o.cloudfront.net/plantilla_solicitud_ese_v1.xlsx" alt="" style={{width: "50px"}}/>
      </a>
    </p>
  
  
  );
};

export default CLinkDescargaPlantillaCrearEse